<template>
  <div>
    <div class="option-card" :class="set_style">
      <div class="avatar brand_green_bg">
        <div
          class="span icon-accept brand_navy font-20 flex-center"
          v-if="option_correct"
        ></div>
        <div
          class="avatar-text text-lowercase color_white_bg color_text"
          v-else
        >
          {{ option_id }}
        </div>
      </div>

      <!-- VALUE -->
      <div
        class="value color_text"
        v-if="option_value"
        v-html="option_value"
      ></div>
      <div class="image-value" v-if="option_image">
        <img v-lazy="option_image" alt />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "OptionCard",

  props: {
    option_id: String,
    option_value: String,
    option_image: String,
    option_correct: {
      type: Boolean,
      default: false,
    },
    option_sm: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      set_style: null,
      option_style: {
        start_sm: "align-items-start option-sm",
        start_only: "align-items-start",
        center_only: "align-items-center",
        sm_only: "option-sm",
      },
    };
  },

  mounted() {
    this.setOptionstyle();
  },

  methods: {
    setOptionstyle() {
      if (this.option_image && this.option_sm) {
        this.set_style = this.option_style.start_sm;
      } else if (!this.option_image && this.option_sm) {
        this.set_style = this.option_style.sm_only;
      } else if (this.option_image) {
        this.set_style = this.option_style.start_only;
      } else if (!this.option_image) {
        this.set_style = this.option_style.center_only;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.option-card {
  // border: 1px solid red;
  width: 300px;
  margin-bottom: 10px;
  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-start !important;
  align-items: flex-start !important;

  @include breakpoint_max(lg) {
    width: 400px;
    margin-bottom: 20px;
  }

  @include breakpoint_max(sm) {
    width: 380px;
    margin-bottom: 5px;
  }

  @include breakpoint_max(xs) {
    width: 320px;
  }

  @include breakpoint_min_max(380, 400) {
    width: 300px;
  }

  @include breakpoint_min_max(350, 379) {
    width: 270px;
  }

  @include breakpoint_min_max(320, 349) {
    width: 240px;
  }

  .avatar {
    @include equal_min_edge(30);
    margin-right: 13px;

    @include breakpoint_max(md) {
      @include equal_min_edge(28);
      margin-right: 10px;

      .span {
        font-size: 17px !important;
      }
      .avatar-text {
        font-size: 11px !important;
      }
    }

    @include breakpoint_max(xs) {
      @include equal_min_edge(26);
      .span {
        font-size: 15px !important;
      }
    }
  }

  .value {
    position: relative;
    top: 7px;
    font-size: 13.5px;
    line-height: 19px;

    @include breakpoint_max(md) {
      font-size: 12.5px;
    }

    @include breakpoint_max(sm) {
      top: 1px;
      font-size: 12px;
      line-height: 18px;
    }
  }

  .image-value {
    @include custom_min_edge(74, 66);

    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }
}

.option-sm {
  width: 210px !important;
}
</style>
